import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class BaseDesignOption extends BaseModel {}
